export function check(accessLevel, userRights) {
  if (typeof accessLevel === 'boolean') return accessLevel;
  if (typeof accessLevel === 'function') return accessLevel(userRights);

  if (Array.isArray(accessLevel)) {
    // If `accessLevel` is an array (i.e. a logical OR), check for at least one match
    return accessLevel.some((entry) => check(entry, userRights));
  }

  if (accessLevel instanceof Set) {
    // If `accessLevel` is `Set` (i.e. a logical AND), we check if the user has all rights
    return [...accessLevel].every((level) => userRights.has(level));
  }

  return userRights.has(accessLevel);
}

export function mergeMask(dict) {
  return (arr) => {
    const resultSet = new Set();
    arr.forEach((item) => {
      resultSet.add(dict[item]);
    });
    return resultSet;
  };
}

function createMask(dictionary) {
  const merge = mergeMask(dictionary);
  return (element) => {
    if (Array.isArray(element)) {
      return merge(element);
    }
    return dictionary[element];
  };
}

/**
 * Helper function
 * @function
 * @name createPolicies
 * @param dict object dictionary of all available rights
 * @param items array of rights for this instance
 *
 * */

export function createPolicies(dict, items) {
  const maker = createMask(dict);

  return items.map((entry) => {
    if (Array.isArray(entry)) {
      // If an array (logical AND) is passed, we create a Set where all elements must be present
      return new Set(entry.map(maker));
    }
    // If it's a single rule, just add it as a separate element
    return maker(entry);
  });
}

export function makeDictionary(arr) {
  return arr.reduce((a, e, i) => ({ ...a, [e]: i }), {});
}

export function arrayFilter(restriction) {
  return (f) => check(f.restriction, restriction);
}

// eslint-disable-next-line max-len
export function arrayMap(restriction, fieldName) {
  return (m) => ({ ...m, [fieldName]: check(m[fieldName], restriction) });
}

export function advancedRights(rules) {
  const pa = Object.keys(rules());
  const dictionary = makeDictionary(pa);
  return {
    dictionary,
    restriction(...args) {
      const r = rules(...args);
      const userRights = new Set();
      pa.forEach((v) => {
        if (r[v]()) {
          userRights.add(dictionary[v]);
        }
      });
      return userRights;
    },
    policy: (...arr) => createPolicies(dictionary, arr),
    paramsName: pa.reduce((a, v) => Object.assign(a, { [v]: v }), { [pa[0]]: pa[0] }),
  };
}
